<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="ExamForm">
        <div class="col-lg-12 col-md-12">
            <div class="card-body mb-2">
                <div *ngIf="submitButton" class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/img/ExamMaster.png" class="mh-45px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                {{'header.exam-data.table.Data'| translate}}
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            {{'header.exam-data.table.Add'| translate}}
                        </p>
                    </div>
                </div>
                <div *ngIf="editButton" class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/img/ExamMaster.png" class="mh-45px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                            {{'header.exam-data.table.Data'| translate}}
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            {{'header.exam-data.table.UpdateExam'| translate}}
                        </p>
                    </div>
                </div>
                <div *ngIf="deleteButton" class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/img/ExamMaster.png" class="mh-45px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                            {{'header.exam-data.table.Data'| translate}}
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            {{'header.exam-data.table.DeleteExam'| translate}}
                        </p>
                    </div>
                </div>
                <div class="mt-3 ">
                    <mat-tab-group class="min" (selectedTabChange)="onTabChanged($event)"
                        [selectedIndex]="selectedIndex" mat-stretch-tabs="false" mat-align-tabs="start">
                        <mat-tab label="Exam">
                            <div (next)="next()" class="card-body pl-pr">
                                <div *ngIf="submitButton">
                                    <h4 class="main-content-label mb-1">
                                        <b>
                                            {{'header.exam-data.table.AddNewExamRecord'| translate}}
                                        </b>
                                    </h4>
                                    <!-- <p class="text-muted card-sub-title mb-0">
                                            {{'header.exam-data.titleList.AddNewInfo'| translate}}
                                            
                                        </p> -->
                                </div>
                                <div *ngIf="editButton">
                                    <h4 class="main-content-label mb-1">
                                        <b>
                                        {{'header.exam-data.table.UpdateRecord'| translate}}
                                        </b>
                                    </h4>
                                    <!-- <p class="text-muted card-sub-title mb-0">
                                            {{'header.exam-data.titleList.UpdateSelectedInfo'|
                                            translate}}
                                            
                                        </p> -->
                                </div>
                                <div *ngIf="deleteButton">
                                    <h4 class="main-content-label mb-1">
                                        <b>
                                            {{'header.exam-data.table.DeleteRecord'| translate}}
                                        </b>
                                    </h4>
                                    <!-- <p class="text-muted card-sub-title mb-0">
                                            {{'header.exam-data.titleList.UpdateSelectedInfo'|
                                            translate}}
                                            
                                        </p> -->
                                </div>

                                <div class="row clearfix mt-3">
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <div class="row">

                                                <div class="col-md-3">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>{{'header.exam-data.table.ExamCourseCode'| translate}}</mat-label>
                                                        <mat-select required #select3  [disabled]="ReadOnlyCo"
                                                            class="colorblack" formControlName="EmCoCode">
                                                            <mat-select-filter *ngIf="select3.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                [array]="CourseList"
                                                                (filteredReturn)="filteredListCourse =$event"></mat-select-filter>
                                                            <mat-option onkeydown="return (event.keyCode!=13);"
                                                                *ngFor="let item of filteredListCourse"
                                                                [value]="item.CoCode" (click)="labelClick(item.CoCode);"
                                                                (onSelectionChange)="labelClick(item.CoCode);"
                                                                (click)="loadExamList2({EmCoCode:item.CoCode})"
                                                                (click)="getCourse(item)"
                                                                (click)="selectExamNoPopulation('true',item)">
                                                                {{item.CoCode}}-{{item.CoName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="ExamForm.controls['EmCoCode'].touched && ExamForm.controls['EmCoCode'].errors?.required">
                                                            {{'header.exam-data.table.Mandatory'| translate}}
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                                <div class="col-md-9 mt-3">
                                                    <mat-label>{{desLabel}}</mat-label>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{'header.exam-data.table.ExamSrNo'| translate}}
                                                    </mat-label>
                                                    <input onkeydown="return (event.keyCode!=13);" readonly
                                                        style="color:black;" type="text" placeholder="Serial No"
                                                        formControlName="EmSrNo" matInput>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{'header.exam-data.table.ExamName'| translate}}
                                                    </mat-label>
                                                    <input appCamelcase onkeydown="return (event.keyCode!=13);"
                                                        [readonly]="deleteReadOnly" style="color:black;" type="text"
                                                        maxlength="80" placeholder="Exam Name" formControlName="EmName"
                                                        matInput required>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmName'].touched && ExamForm.controls['EmName'].errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width ">
                                                    <mat-label>
                                                        {{'header.exam-data.table.ExamCode'| translate}}
                                                    </mat-label>
                                                    <input appUppercase [readonly]="emCodeRead || deleteReadOnly" 
                                                        onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                        type="text" placeholder="Exam Code" formControlName="EmCode"
                                                        maxlength="6" matInput required>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmCode'].touched && ExamForm.controls['EmCode'].errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmCode'].touched && ExamForm.controls['EmCode'].errors?.pattern">
                                                        {{'header.exam-data.table.Invalid'| translate}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width ">
                                                    <mat-label>
                                                        {{'header.exam-data.table.ExamShName'| translate}}
                                                    </mat-label>
                                                    <input maxlength="20" onkeydown="return (event.keyCode!=13);"
                                                        [readonly]="deleteReadOnly" style="color:black;" type="text"
                                                        placeholder="Short Name" formControlName="EmShName" matInput
                                                        required>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmShName'].touched && ExamForm.controls['EmShName'].errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 hidden">
                                        <div class="form-group">
                                            <div class="">
                                                <section class="example-section mt-2">
                                                    <mat-checkbox [disabled]="deleteReadOnly" class="example-margin "
                                                        formControlName="EmColg">
                                                        {{'header.exam-data.table.ExamCollege'| translate}}</mat-checkbox>

                                                </section>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 mt-2 hidden">
                                        <div class="form-group">
                                            <div class="">
                                                <section class="example-section ">
                                                    <mat-checkbox [disabled]="deleteReadOnly" class="example-margin "
                                                        formControlName="EmGrps">
                                                       {{'header.exam-data.table.ExamGroups'| translate}}</mat-checkbox>

                                                </section>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="form-group">
                                            <div class="">
                                                <div class="row">
                                                    <div class="col-sm-4 mt-2">
                                                        <mat-label class="mt-1 lclass"><span
                                                                class="required-asterisk mr-1"></span>{{'header.exam-data.table.ExamStream'| translate}}</mat-label>
                                                    </div>
                                                    <div class="col-sm-8">
                                                        <mat-radio-group [disabled]="deleteReadOnly || Read"
                                                            formControlName="EmStreams" class="example-full-width">
                                                            <div class="row">
                                                                <div class="col-sm-6 mt-2">
                                                                    <mat-radio-button value='Y'>{{'header.exam-data.table.Yes'| translate}}</mat-radio-button>
                                                                </div>
                                                                <div class="col-sm-5 mt-2">
                                                                    <mat-radio-button value='N'>{{'header.exam-data.table.No'| translate}}</mat-radio-button>
                                                                </div>
                                                            </div>
                                                        </mat-radio-group>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="form-group" *ngIf="ExamFormArray['EmSubTot'][0]['FormVisible']">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>{{ExamFormArray['EmSubTot'][0]['FormDisplayName']}}
                                                        <!-- <span *ngIf="ExamFormArray['EmSubTot'][0]['FormRequired']">*</span> -->
                                                    </mat-label>

                                                    <mat-select
                                                        [required]="ExamFormArray['EmSubTot'][0]['FormRequired']"
                                                        [disabled]="deleteReadOnly" #select33 placeholder="EmSubTot"
                                                        class="colorblack" formControlName="EmSubTot">
                                                        <mat-select-filter *ngIf="select33.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                            [array]="subtotalList"
                                                            (filteredReturn)="filteredsubtotalList =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredsubtotalList"
                                                            [value]="item.CdCode">
                                                            {{item.CdDesc}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmSubTot'].touched && ExamForm.controls['EmSubTot'].errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                </mat-form-field>

                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-sm-2">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Use Sub Total</mat-label>
                                                    <mat-select [disabled]="deleteReadOnly" #select38 class="colorblack"
                                                        formControlName="EmSubTot">
                                                        <mat-select-filter *ngIf="select38.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'CdCode'"
                                                            [array]="subtotalList"
                                                            (filteredReturn)="filteredsubtotalList =$event"></mat-select-filter>
                                                        <mat-option onkeydown="return (event.keyCode!=13);"
                                                            *ngFor="let item of filteredsubtotalList"
                                                            [value]="item.CdCode">
                                                            {{item.CdDesc}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmSubTot'].touched && ExamForm.controls['EmSubTot'].errors?.pattern">
                                                        Invalid
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmSubTot'].touched && ExamForm.controls['EmSubTot'].errors?.required">
                                                        Mandatory
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div> -->


                                    <div class="col-sm-2 hidden">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width ">
                                                    <mat-label>
                                                        {{'header.exam-data.table.ExamClrSrNo'| translate}}
                                                    </mat-label>
                                                    <input onkeydown="return (event.keyCode!=13);"
                                                        [readonly]="deleteReadOnly" maxlength="2" style="color:black;"
                                                        type="text" placeholder="Elgb Clr Exam"
                                                        formControlName="EmClrSrNo" matInput>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmClrSrNo'].touched && ExamForm.controls['EmClrSrNo'].errors?.pattern">
                                                        {{'header.exam-data.table.Invalid'| translate}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-sm-2">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Elgb-Rule</mat-label>

                                                    <mat-select [disabled]="deleteReadOnly" #select333
                                                        placeholder="EmElgblCd" class="colorblack"
                                                        formControlName="EmElgblCd">
                                                        <mat-select-filter *ngIf="select333.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                            [array]="elgbRuleList"
                                                            (filteredReturn)="filteredElgbRuleList =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredElgbRuleList"
                                                            [value]="item.CdCode" (click)="getValue(item.CdDesc)">
                                                            {{item.CdDesc}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4" formArrayName="marksGrid">
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-4"
                                                    *ngFor="let option of  getmarksGridControls(); let i = index"
                                                    [formGroupName]="i">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label class="mt-0 mb-0">
                                                            {{value}}
                                                        </mat-label>
                                                        <input matTooltip="{{value}}" class="color" matInput
                                                            formControlName="FailInValue" autocomplete="off"
                                                            maxlength="3" onkeydown="return (event.keyCode!=13);"
                                                            [readonly]="deleteReadOnly" required>

                                                        <mat-error class="margin_tp"
                                                            *ngIf="option.controls.FailInValue.touched && option.controls.FailInValue.errors?.required">
                                                            Mandatory
                                                        </mat-error>
                                                        <mat-error class="margin_tp"
                                                            *ngIf="option.controls.FailInValue.touched && option.controls.FailInValue.errors?.pattern">
                                                            Invalid
                                                        </mat-error>
                                                    </mat-form-field>

                                                </div>

                                            </div>
                                        </div>
                                    </div> -->
                                    
                                    <div class="col-sm-2 hidden" *ngIf="ExamFormArray['EmATKTSub'][0]['FormVisible']">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width ">
                                                    <mat-label>
                                                        {{ExamFormArray['EmATKTSub'][0]['FormDisplayName']}}
                                                        <!-- <span *ngIf="ExamFormArray['EmATKTSub'][0]['FormRequired']">*</span> -->
                                                    </mat-label>
                                                    <input [required]="ExamFormArray['EmATKTSub'][0]['FormRequired']"
                                                        onkeydown="return (event.keyCode!=13);"
                                                        [readonly]="deleteReadOnly" maxlength="2" style="color:black;"
                                                        type="text" placeholder="Total Fail Sub"
                                                        formControlName="EmATKTSub" matInput>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmATKTSub']?.touched && ExamForm.controls['EmATKTSub']?.errors?.pattern">
                                                        {{'header.exam-data.table.Invalid'| translate}}
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmATKTSub']?.touched && ExamForm.controls['EmATKTSub']?.errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="col-sm-2" *ngIf="ExamFormArray['EmCompart'][0]['FormVisible']">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{ExamFormArray['EmCompart'][0]['FormDisplayName']}}
                                                        <!-- <span *ngIf="ExamFormArray['EmCompart'][0]['FormRequired']">*</span> -->
                                                    </mat-label>
                                                    <input [required]="ExamFormArray['EmCompart'][0]['FormRequired']"
                                                        formControlName="EmCompart"
                                                        onkeydown="return (event.keyCode!=13);"
                                                        [readonly]="deleteReadOnly" maxlength="3" style="color:black;"
                                                        type="text" placeholder="Compartment" matInput>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmCompart'].touched && ExamForm.controls['EmCompart'].errors?.pattern">
                                                        {{'header.exam-data.table.Invalid'| translate}}
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmCompart'].touched && ExamForm.controls['EmCompart'].errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2" *ngIf="RadioButn">
                                        <div class="form-group">
                                            <div class="">
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <mat-radio-group [disabled]="deleteReadOnly"
                                                            class="example-full-width">
                                                            <div class="row">
                                                                <div class="col-sm-7 p-1 mt-2 mr-4">
                                                                    <mat-radio-button value="S"
                                                                        (click)="CompValue('S')" [checked]="selectedRadio === 'S'">{{'header.exam-data.table.ExamFailSub'| translate}}</mat-radio-button>
                                                                </div>
                                                                <div class="col-sm-5 p-1 mt-2">
                                                                    <mat-radio-button value="P" [checked]="selectedRadio === 'P'"
                                                                        (click)="CompValue('P')">{{'header.exam-data.table.ExamPapers'| translate}}</mat-radio-button>
                                                                </div>
                                                            </div>
                                                        </mat-radio-group>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-sm-2" *ngIf="Practical">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        Practical Delayed
                                                    </mat-label>
                                                    <mat-select formControlName="EmCompart" #select56
                                                        [disabled]="deleteReadOnly">
                                                        <mat-option value="Y">Yes</mat-option>
                                                        <mat-option value="N">No</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div> -->

                                    <div class="col-sm-2" *ngIf="ExamFormArray['EmTotSub'][0]['FormVisible']">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{ExamFormArray['EmTotSub'][0]['FormDisplayName']}}
                                                        <!-- <span
                                                                *ngIf="ExamFormArray['EmTotSub'][0]['FormRequired']">*</span> -->
                                                    </mat-label>
                                                    <input [required]="ExamFormArray['EmTotSub'][0]['FormRequired']"
                                                        onkeydown="return (event.keyCode!=13);"
                                                        [readonly]="deleteReadOnly" maxlength="3" style="color:black;"
                                                        type="text" matInput placeholder="Total Sub"
                                                        formControlName="EmTotSub"
                                                        (change)="condition($event.target.value)">

                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmTotSub'].touched && ExamForm.controls['EmTotSub'].errors?.pattern">
                                                        {{'header.exam-data.table.Invalid'| translate}}
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="this.ExamForm.get('EmTotSub').errors?.minIsGreaterThanMax">Total
                                                        Subjects cannot be less than Total Failed
                                                        Subjects
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmTotSub'].touched && ExamForm.controls['EmTotSub'].errors?.required">
                                                        {{'header.exam-data.table.Mandatoy'| translate}}
                                                    </mat-error>
                                                </mat-form-field>


                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2" *ngIf="ExamFormArray['EmMaxTot'][0]['FormVisible']">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{ExamFormArray['EmMaxTot'][0]['FormDisplayName']}}
                                                        <!-- <span *ngIf="ExamFormArray['EmMaxTot'][0]['FormRequired']">*</span> -->
                                                    </mat-label>
                                                    <input [required]="ExamFormArray['EmMaxTot'][0]['FormRequired']"
                                                        onkeydown="return (event.keyCode!=13);"
                                                        [readonly]="deleteReadOnly" maxlength="4" style="color:black;"
                                                        type="text" formControlName="EmMaxTot" placeholder="Total Marks"
                                                        matInput>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmMaxTot'].touched && ExamForm.controls['EmMaxTot'].errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmMaxTot'].touched && ExamForm.controls['EmMaxTot'].errors?.pattern">
                                                        {{'header.exam-data.table.Invalid'| translate}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div  *ngIf="hideForOneSrNo" class="col-sm-2">
                                        <div class="form-group">
                                            <div class="">
                                                <div class="row">
                                                    <div class="col-sm-4 mt-2">
                                                        <mat-label class="mt-1 lclass"><span
                                                                class="required-asterisk mr-1"></span>{{'header.exam-data.table.ExamLatEntry'| translate}}</mat-label>
                                                    </div>
                                                    <div class="col-sm-8">
                                                        <mat-radio-group [disabled]="deleteReadOnly"
                                                            formControlName="EmLatEntry" class="example-full-width">
                                                            <div class="row">
                                                                <div class="col-sm-6 mt-2">
                                                                    <mat-radio-button value='Y'>{{'header.exam-data.table.Yes'| translate}}</mat-radio-button>
                                                                </div>
                                                                <div class="col-sm-5 mt-2">
                                                                    <mat-radio-button value='N'>{{'header.exam-data.table.No'| translate}}</mat-radio-button>
                                                                </div>
                                                            </div>
                                                            <!-- <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='Y'>Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='N'>No</mat-radio-button>
                                                                    </div>
                                                                </div> -->
                                                        </mat-radio-group>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 hidden">
                                        <div class="form-group">
                                            <div class="">
                                                <!-- <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>
                                                            Rej/Improv
                                                            </mat-label>
                                                            <input style="color:black;" type="text" maxlength="1"  formControlName="EmRejImpr"
                                                                placeholder="Rej/Impr" 
                                                                matInput >
                                                        </mat-form-field> -->
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Rej/Improv</mat-label>
                                                    <mat-select [disabled]="deleteReadOnly" formControlName="EmRejImpr">
                                                        <mat-option class="blue" value="I">Improve</mat-option>
                                                        <mat-option class="red" value="R">Reject</mat-option>
                                                        <mat-option value="N">Not
                                                            Applicable</mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmRejImpr'].touched && ExamForm.controls['EmRejImpr'].errors?.pattern">
                                                        {{'header.exam-data.table.Invalid'| translate}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 hidden">
                                        <div class="form-group" *ngIf="ExamFormArray['EmVal'][0]['FormVisible']">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{ExamFormArray['EmVal'][0]['FormDisplayName']}}
                                                        <!-- <span *ngIf="ExamFormArray['EmVal'][0]['FormRequired']">*</span> -->
                                                    </mat-label>
                                                    <input [required]="ExamFormArray['EmVal'][0]['FormRequired']"
                                                        onkeydown="return (event.keyCode!=13);"
                                                        [readonly]="deleteReadOnly" style="color:black;" type="text"
                                                        maxlength="1" formControlName="EmVal" placeholder="Valuations"
                                                        matInput>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmVal'].touched && ExamForm.controls['EmVal'].errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmVal'].touched && ExamForm.controls['EmVal'].errors?.pattern">
                                                        {{'header.exam-data.table.Invalid'| translate}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 hidden">
                                        <div class="form-group" *ngIf="ExamFormArray['EmValDev'][0]['FormVisible']">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{ExamFormArray['EmValDev'][0]['FormDisplayName']}}
                                                        <!-- <span *ngIf="ExamFormArray['EmValDev'][0]['FormRequired']">*</span> -->
                                                    </mat-label>
                                                    <input [required]="ExamFormArray['EmValDev'][0]['FormRequired']"
                                                        onkeydown="return (event.keyCode!=13);"
                                                        [readonly]="deleteReadOnly" style="color:black;" type="text"
                                                        maxlength="2" formControlName="EmValDev"
                                                        placeholder="Deviations" matInput>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmValDev'].touched && ExamForm.controls['EmValDev'].errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmValDev'].touched && ExamForm.controls['EmValDev'].errors?.pattern">
                                                        {{'header.exam-data.table.Invalid'| translate}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="form-group">
                                            <div class="">

                                                <!-- getEvaluation formControlName="EmEval"-->
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>{{'header.exam-data.table.ExamEval'| translate}}</mat-label>
                                                    <mat-select #select390 placeholder="Evaluation" class="colorblack"
                                                        formControlName="EmEval" [disabled]="deleteReadOnly">
                                                        <mat-select-filter *ngIf="select390.focused"
                                                            [placeholder]="'Evaluation'" [displayMember]="'CdDesc'"
                                                            [array]="evaluationList"
                                                            (filteredReturn)="filteredListOfEmEval =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListOfEmEval"
                                                            [value]="item.CdCode">
                                                            {{item.CdDesc}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <!-- *ngIf="item.CoMarkList != null -->
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="form-group" *ngIf="ExamFormArray['EmPassPC'][0]['FormVisible']">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{ExamFormArray['EmPassPC'][0]['FormDisplayName']}}
                                                    </mat-label>
                                                    <input onkeydown="return (event.keyCode!=13);"
                                                        [readonly]="deleteReadOnly" style="color:black;" type="text"
                                                        maxlength="5" formControlName="EmPassPC" placeholder="Pass %"
                                                        matInput>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmPassPC'].touched && ExamForm.controls['EmPassPC'].errors?.pattern">
                                                        {{'header.exam-data.table.Invalid'| translate}}
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmPassPC'].touched && ExamForm.controls['EmPassPC'].errors?.max">
                                                        Enter Less Than 100%
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div  class="col-sm-2">
                                        <div class="form-group" *ngIf="ExamFormArray['EmMarkList'][0]['FormVisible']">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>{{ExamFormArray['EmMarkList'][0]['FormDisplayName']}}
                                                        <!-- <span *ngIf="ExamFormArray['EmMarkList'][0]['FormRequired']">*</span> -->
                                                    </mat-label>

                                                    <mat-select
                                                        [required]="ExamFormArray['EmMarkList'][0]['FormRequired']"
                                                        [disabled]="deleteReadOnly" #select33 placeholder="EmMarkList"
                                                        class="colorblack" formControlName="EmMarkList">
                                                        <mat-select-filter *ngIf="select33.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                            [array]="markList"
                                                            (filteredReturn)="filteredListOfMark =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListOfMark"
                                                            [value]="item.CdCode">
                                                            {{item.CdDesc}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmMarkList'].touched && ExamForm.controls['EmMarkList'].errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                    <!-- *ngIf="item.CoMarkList != null -->
                                                </mat-form-field>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2 hidden" *ngIf="ExamFormArray['EmConv'][0]['FormVisible']">
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-5 mt-2">
                                                    <mat-label class="mt-1 lclass">
                                                        {{ExamFormArray['EmConv'][0]['FormDisplayName']}}
                                                        <!-- <span *ngIf="ExamFormArray['EmConv'][0]['FormRequired']">*</span> -->
                                                    </mat-label>
                                                </div>
                                                <div class="col-sm-7">
                                                    <mat-radio-group
                                                        [required]="ExamFormArray['EmConv'][0]['FormRequired']"
                                                        [disabled]="deleteReadOnly" formControlName="EmConv"
                                                        class="example-full-width">
                                                        <div class="row">
                                                            <div class="col-sm-6 p-1 mt-2">
                                                                <mat-radio-button value='Y'>{{'header.exam-data.table.Yes'| translate}}</mat-radio-button>
                                                            </div>
                                                            <div class="col-sm-5 p-1 mt-2">
                                                                <mat-radio-button value='N'>{{'header.exam-data.table.No'| translate}}</mat-radio-button>
                                                            </div>

                                                        </div>
                                                    </mat-radio-group>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmConv'].touched && ExamForm.controls['EmConv'].errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                            <!-- 22.02.2024 -->
                                    <div class="col-sm-2" *ngIf="ExamFormArray['EmDiv'][0]['FormVisible']">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>  {{ExamFormArray['EmDiv'][0]['FormDisplayName']}}</mat-label>
                                                    <mat-select [disabled]="deleteReadOnly" #select556
                                                        class="colorblack" formControlName="EmDiv">
                                                        <mat-select-filter *ngIf="select556.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                            [array]="codeTypeList"
                                                            (filteredReturn)="filteredCodeType =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredCodeType"
                                                            [value]="item.CdCode">
                                                            {{item.CdDesc}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                               
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div class="col-sm-2 mt-3">
                                                <div   class="form-group">
                                                    <div class="">
                                                        <section class="example-section ">
                                                            <mat-checkbox [disabled]="deleteReadOnly" class="example-margin "
                                                                formControlName="EmMarksD">Decimal Marks</mat-checkbox>

                                                        </section>
                                                        
                                                    </div>
                                                </div>
                                            </div> -->
                                    <div class="col-sm-2">
                                        <div class="form-group"
                                            *ngIf="ExamFormArray['EmDivFirstMrk'][0]['FormVisible']">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{ExamFormArray['EmDivFirstMrk'][0]['FormDisplayName']}}
                                                        <!-- <span *ngIf="ExamFormArray['EmDivFirstMrk'][0]['FormRequired']">*</span> -->
                                                    </mat-label>
                                                    <mat-select
                                                        [required]="ExamFormArray['EmDivFirstMrk'][0]['FormRequired']"
                                                        [disabled]="deleteReadOnly" #select55 class="colorblack"
                                                        formControlName="EmDivFirstMrk">
                                                        <mat-select-filter *ngIf="select55.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'CdDesc'"
                                                            [array]="classRuleList"
                                                            (filteredReturn)="filteredListClass =$event"></mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListClass"
                                                            [value]="item.CdCode">
                                                            {{item.CdDesc}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmDivFirstMrk'].touched && ExamForm.controls['EmDivFirstMrk'].errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                </mat-form-field>
                                                <!-- <input maxlength="25" onkeydown="return (event.keyCode!=13);"  [readonly]="deleteReadOnly" style="color:black;" type="text"  formControlName="EmDivFirstMrk"
                                                                placeholder="Class-Rule" 
                                                                matInput > -->

                                            </div>
                                        </div>
                                    </div>


                                    <div class="col-sm-2 mt-3 hidden">
                                        <div class="form-group">
                                            <div class="">
                                                <section class="example-section ">
                                                    <mat-checkbox [disabled]="deleteReadOnly" class="example-margin "
                                                        formControlName="EmDivFirstAtt">For 1st
                                                        Attempt</mat-checkbox>

                                                </section>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-2 mt-3">
                                        <div class="form-group" *ngIf="ExamFormArray['EmMarksD'][0]['FormVisible']">
                                            <div class="">
                                                <section class="example-section ">
                                                    <mat-checkbox
                                                        [required]="ExamFormArray['EmMarksD'][0]['FormRequired']"
                                                        [disabled]="deleteReadOnly" class="example-margin "
                                                        formControlName="EmMarksD">{{ExamFormArray['EmMarksD'][0]['FormDisplayName']}}
                                                        <!-- <span *ngIf="ExamFormArray['EmMarksD'][0]['FormRequired']">*</span> -->
                                                    </mat-checkbox>

                                                </section>
                                                <mat-error class="margin_tp"
                                                    *ngIf="ExamForm.controls['EmMarksD'].touched && ExamForm.controls['EmMarksD'].errors?.required">
                                                    {{'header.exam-data.table.Mandatory'| translate}}
                                                </mat-error>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="form-group" *ngIf="ExamFormArray['EmExmSuppl'][0]['FormVisible']">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{ExamFormArray['EmExmSuppl'][0]['FormDisplayName']}}
                                                        <!-- <span *ngIf="ExamFormArray['EmExmSuppl'][0]['FormRequired']">*</span> -->
                                                    </mat-label>
                                                    <mat-select
                                                        [required]="ExamFormArray['EmExmSuppl'][0]['FormRequired']"
                                                        [disabled]="deleteReadOnly" formControlName="EmExmSuppl">
                                                        <mat-option class="blue" value="Suppl">Suppl</mat-option>
                                                        <mat-option class="red" value="Quali">Quali</mat-option>
                                                    </mat-select>

                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmExmSuppl'].touched && ExamForm.controls['EmExmSuppl'].errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                </mat-form-field>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="form-group" *ngIf="ExamFormArray['EmDebar'][0]['FormVisible']">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{ExamFormArray['EmDebar'][0]['FormDisplayName']}}
                                                        <!-- <span *ngIf="ExamFormArray['EmDebar'][0]['FormRequired']">*</span> -->
                                                    </mat-label>
                                                    <mat-select [required]="ExamFormArray['EmDebar'][0]['FormRequired']"
                                                        [disabled]="deleteReadOnly" formControlName="EmDebar">
                                                        <mat-option class="blue" value="Cours">Course</mat-option>
                                                        <mat-option value=" "> </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmDebar'].touched && ExamForm.controls['EmDebar'].errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="form-group" *ngIf="ExamFormArray['EmDebarNo'][0]['FormVisible']">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{ExamFormArray['EmDebarNo'][0]['FormDisplayName']}}
                                                        <!-- <span *ngIf="ExamFormArray['EmDebarNo'][0]['FormRequired']">*</span> -->
                                                    </mat-label>
                                                    <input [required]="ExamFormArray['EmDebarNo'][0]['FormRequired']"
                                                        maxlength="2" onkeydown="return (event.keyCode!=13);"
                                                        [readonly]="deleteReadOnly" style="color:black;" type="text"
                                                        formControlName="EmDebarNo" placeholder="" matInput>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmDebarNo'].touched && ExamForm.controls['EmDebarNo'].errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmDebarNo'].touched && ExamForm.controls['EmDebarNo'].errors?.pattern">
                                                        {{'header.exam-data.table.Invalid'| translate}}
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="form-group" *ngIf="ExamFormArray['EmDebarType'][0]['FormVisible']">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{ExamFormArray['EmDebarType'][0]['FormDisplayName']}}
                                                        <!-- <span *ngIf="ExamFormArray['EmDebarType'][0]['FormRequired']">*</span> -->
                                                    </mat-label>
                                                    <!-- <input  onkeydown="return (event.keyCode!=13);" [readonly]="deleteReadOnly"  style="color:black;" type="text"  formControlName="EmDebarType"
                                                                placeholder="Debar Type" 
                                                                matInput > -->
                                                    <mat-select
                                                        [required]="ExamFormArray['EmDebarType'][0]['FormRequired']"
                                                        onkeydown="return (event.keyCode!=13);"
                                                        [disabled]="deleteReadOnly" formControlName="EmDebarType">
                                                        <mat-option class="blue" value="Chanc">Chance</mat-option>
                                                        <mat-option value=" "> </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="ExamForm.controls['EmDebarType'].touched && ExamForm.controls['EmDebarType'].errors?.required">
                                                        {{'header.exam-data.table.Mandatory'| translate}}
                                                    </mat-error>
                                                </mat-form-field>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="row col-sm-12">
                                        <div class="col-sm-12 prpl">
                                            <button id="Delete" *ngIf="deleteButton && ExDelete" type="button"
                                                class="btn size btn-primary btn-icon-text floatright mt-1"
                                                (click)="openConformationModalBox()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/trash.gif"
                                                        style="margin-right: 5px;">
                                                    {{'header.exam-data.table.Delete'| translate}}
                                                </span>
                                            </button>
                                            <button id="Update" *ngIf="editButton && ExUpdate" type="button"
                                                class="btn size btn-primary btn-icon-text floatright mt-1 "
                                                (click)="update()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/edit1.gif"
                                                        style="margin-right: 5px;">
                                                    {{'header.exam-data.table.Update'| translate}}
                                                </span>
                                            </button>
                                            <button id="Save" *ngIf="submitButton && ExCreate" type="button"
                                                class="btn size btn-primary btn-icon-text floatright mt-1"
                                                (click)="submit()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/save.gif"
                                                        style="margin-right: 5px;">
                                                    {{'header.exam-data.table.Save'| translate}}
                                                </span>
                                            </button>
                                            <button id="Back" type="button" [mat-dialog-close]="true"
                                                class="btn size btn-primary btn-icon-text floatright mr-3 mt-1">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/turn-left.gif"
                                                        style="margin-right: 7px;">
                                                    {{'header.exam-data.table.Back'| translate}}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                    
                                </div>
                                <hr *ngIf="isDiv==true">
                                <div *ngIf="isDiv==true">
                                    <h4 class="main-content-label mb-1">
                                        <b>{{'header.exam-data.table.List'|translate}}</b>
                                    </h4>
                                    <p class="text-muted card-sub-title mb-0">
                                        {{'header.exam-data.table.ExamDataSelectedCourse'|translate}}</p>
                                </div>
                                <hr *ngIf="isDiv==true">
                                <div *ngIf="isDiv==true" class="table-responsive table-container ">
                                    <table appShortTable class="table table-bordered text-nowrap">
                                        <thead>
                                            <tr>

                                                <th class="f600">
                                                    {{'header.exam-data.table.ExamCode'| translate}}
                                                </th>
                                                <th class="f600">
                                                    {{'header.exam-data.table.ExamName'| translate}}
                                                </th>
                                                <th class="f600">
                                                    {{'header.exam-data.table.ExamShName'|
                                                    translate}}
                                                </th>



                                                <th class="f600 text-center">
                                                    {{'header.exam-data.table.Action'| translate}}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody id="table_data">
                                            <tr *ngFor="let exam of examList2;">

                                                <td>{{exam.EmCode}} </td>
                                                <td>{{exam.EmName}} </td>
                                                <td> {{exam.EmShName}} </td>

                                                <td class="text-center">

                                                    <a class="floating" title="Edit" (click)="editdata('true',exam)">
                                                        <i class="fa fa-edit"></i>
                                                    </a>
                                                    <a class="floating" title="Delete" (click)="deletee('true',exam)">
                                                        <i class="fas fa-trash"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                        </mat-tab>
                        <mat-tab label="Exam Division" *ngIf="ExamAggregateTab && ExamDivisionView"  [disabled]="ExamDivisionDisabled">
                            <div class="card-body">
                                <app-exam-division-data (prev)="prev()"></app-exam-division-data>
                            </div>
                        </mat-tab>
                        <mat-tab label="Exam Aggregate" *ngIf="ExamAggregateTab && ExamAggrigateView" [disabled]="ExamAggregateDisabled">
                            <div class="card-body">
                                <app-exam-aggregate (prev)="prev()"></app-exam-aggregate>
                            </div>
                        </mat-tab>
                        <mat-tab *ngIf="SemTab && ExamSemesterView"  label="Semester" [disabled]="SemesterDisabled">
                            <div class="card-body">
                                <app-exam-semester-data (prev)="prev()"></app-exam-semester-data>
                            </div>
                        </mat-tab>
                        <mat-tab *ngIf="DefGrd"  label="DefineGrade" [disabled]="DefGrdDisabled">
                            <!--  -->
                            <div class="card-body">
                                <app-define-grade (prev)="prev()"></app-define-grade>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>

            </div>
        </div>
    </form>
</div>